import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)

/**
 * Simple pluralization filter
 * @param  {string} val
 * @param  {int} num
 * @return {string}
 */
export const pluralize = (val, num) => {
	if (Math.abs(num) === 1) {
		return val;
	}

	return val + 's';
}

/**
 * Standard comment date format filter
 * @param  {string} date
 * @return {string}
 */
export const commentDate = (date, timezone = dayjs.tz.guess() || window._userTimezone) => {
	const targetDate = dayjs.tz(date, 'Europe/London');
	const currentDate = dayjs();

	let dateDisplayed = targetDate.tz(timezone).format('L');

	if (targetDate.isSame(currentDate, 'day')) {
		dateDisplayed = targetDate.tz(timezone).format('HH:mm');
	} else if (targetDate.clone().add(1, 'day').isSame(currentDate, 'day')) {
		dateDisplayed = targetDate.tz(timezone).format('[yesterday@]HH:mm');
	} else if (targetDate.isSame(currentDate, 'year')) {
		dateDisplayed = targetDate.tz(timezone).format('MMM D');
	}

	return dateDisplayed;
}

/**
 * Standard time from now filter
 * @param  {string} date
 * @param  {string} now
 * @return {string}
 */
export const fromNow = (date, now) => {
	const targetDate = dayjs.tz(date, 'Europe/London');
	const currentDate = dayjs(now) || dayjs();

	return targetDate.from(currentDate);
}

/**
 * Standard full datetime format filter
 * @param  {string} date
 * @return {string}
 */
export const fullDatetime = (date, timezone = dayjs.tz.guess() || window._userTimezone) => {
	const targetDate = dayjs.tz(date, 'Europe/London');

	return targetDate.tz(timezone).format('YYYY-MM-DD HH:mm:ss');
}
